import styled from 'styled-components';

import { adSlotConfig } from '../../ad-slot-config';
import { useDefineSlot } from '../../hooks/use-define-slot';

const AdContainer = styled.div`
  min-height: 280px;
  max-height: 300px;
  margin: 0 auto;
`;

export const DisplayAdStartpageRectangle01: React.FC<{ refresh: boolean }> = ({
  refresh,
}) => {
  const slotConfig = adSlotConfig.Startpage.Rectangle01;
  useDefineSlot({ ...slotConfig, refresh });

  return <AdContainer id={slotConfig.id} />;
};
